import { render, staticRenderFns } from "./RealTimeInventoryCard.vue?vue&type=template&id=2f8c5e4a"
import script from "./RealTimeInventoryCard.vue?vue&type=script&lang=js"
export * from "./RealTimeInventoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports